import React, { Suspense } from "react";
const VerifyLoginPageWrapper = React.lazy(() => import("../components/VerifyLoginPageWrapper"));

function VerifyLoginPage() {
  return (
    <Suspense
      fallback={
        <>
          Loading...
        </>
      }
    >
      <VerifyLoginPageWrapper />
    </Suspense>
  );
}

export default VerifyLoginPage;
